import React from 'react';

const ZeroPaddedIndex = (({index}) => (
    <span>{index < 9 ? `0${index+1}` : index+1}</span>
));

export default ZeroPaddedIndex;
